import { z } from 'zod';

const Env = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_PUBLIC_BASE_URL: z.string().url(),
  // IAM (handoff login). Defaults match the local dev stack.
  VITE_AUTH_API_URL: z.string().url().default('http://localhost:3001'),
  VITE_AUTH_FRONTEND_URL: z.string().url().default('http://localhost:5173'),
  VITE_PROJECT_SLUG: z.string().default('therealligue'),
  // The canonical hostname (without port) where the main app lives.
  // Any other hostname is treated as a custom domain — the app resolves its tenant/league context
  // by calling GET /api/site/resolve.
  VITE_CANONICAL_HOST: z.string().default('localhost'),
});

export const env = Env.parse(import.meta.env);
